import * as ActionTypes from './actionTypes'

// Dispatch `SET_IS_DASHBOARD_OPEN`
export function setIsDashboardOpen(isDashboardOpen) {
    return dispatch => {
        dispatch({ type: ActionTypes.SET_IS_DASHBOARD_OPEN, payload: { isDashboardOpen } })
    }
}